import type {Support} from '../../../../../../api/model/response/documents/public/Document';

export const getFaqIdFromDoc = (doc, country, language) => {
    const idFaq = doc._id?.includes('SE-FAQ-');

    if (idFaq) {
      const idSplit = doc._id?.toString()?.split('-');
      return `https://www.se.com/${country}/${language}/faqs/${idSplit[idSplit.length - 1]}/`;
    }
    return doc.video?.url;
};

export const parseVideoId = (url: string) => {
    const searchParams = new URLSearchParams(new URL(url)?.search);
    const optionalItems = url.split('/');

    return searchParams.has('v') ? searchParams.get('v') : optionalItems[optionalItems?.length - 1];
};

export const prepareThumbnailImageUrl = (id: string) => {
    return `https://img.youtube.com/vi/${id}/0.jpg`;
};

export const getThumbnailDetails = (doc: Support, country, language) => {
    const videoDetails: any = Array.isArray(doc.video) && doc?.video?.length > 0 ? doc?.video[0] : doc?.video;  //eslint-disable-line
    const videoId = parseVideoId(videoDetails?.url);
    const thumbnailImageUrl = prepareThumbnailImageUrl(videoId);

    return {
      thumbnailImageUrl: thumbnailImageUrl,
      faqId: doc.documentReference ? '' : getFaqIdFromDoc(doc, country, language),
      videoUrl: getFaqIdFromDoc(doc, country, language),
      videoId: videoId,
    };
};
